import { useEffect, useRef } from "react";
import type { Me } from "@omnabase/shared";
import { api } from "./api";

/** The working hours round (2026-11-01; brief docs/briefs/working-hours-round.md rule 5, the red team's finding 20): on the first session load
 *  after sign-in, when the profile has no time zone, the browser's zone is sent once, quietly, as `detectedTimezone`. The server writes it only
 *  while the profile's zone is still empty, so a second tab or another laptop never overwrites a zone the person chose; a refusal (a zone the
 *  server does not know) is ignored. No message, no travel detection. */
export const browserZone = (): string | null => { try { return Intl.DateTimeFormat().resolvedOptions().timeZone || null; } catch { return null; } };

export function useDetectTimezone(me: Me, reloadMe: () => Promise<void>): void {
  const sent = useRef(false);
  const empty = me.profile.timezone === null;
  useEffect(() => {
    if (!empty || sent.current) return;
    const zone = browserZone();
    if (!zone) return;
    sent.current = true;
    void api.patch("/api/v1/me/profile", { detectedTimezone: zone }).then(() => reloadMe(), () => undefined);
  }, [empty, reloadMe]);
}
